import { apiFetch } from "./apiClient";
import CONFIG from "../config";

export function validateE164(phoneNumber) {
  if (!phoneNumber || typeof phoneNumber !== "string") return false;
  return /^\+[1-9]\d{1,14}$/.test(phoneNumber.trim());
}

export async function prepareInboundCall(scenarioId, phoneNumber, sessionId, agentTransferNumber = null, noiseProfile = null) {
  const body = { scenario_id: scenarioId, phone_number: phoneNumber, session_id: sessionId };
  if (agentTransferNumber) {
    body.agent_transfer_number = agentTransferNumber;
  }
  if (noiseProfile && noiseProfile !== "quiet") {
    body.noise_profile = noiseProfile;
  }
  return apiFetch(`${CONFIG.apiUrl}api/calls/inbound/prepare`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function initiateOutboundCall(scenarioId, phoneNumber, sessionId = null, agentTransferNumber = null, noiseProfile = null) {
  if (!validateE164(phoneNumber)) {
    const error = new Error("Phone number must be in E.164 format");
    error.isValidationError = true;
    throw error;
  }
  const body = { scenario_id: scenarioId, phone_number: phoneNumber };
  if (sessionId) body.session_id = sessionId;
  if (agentTransferNumber) body.agent_transfer_number = agentTransferNumber;
  if (noiseProfile && noiseProfile !== "quiet") body.noise_profile = noiseProfile;
  return apiFetch(`${CONFIG.apiUrl}api/calls/outbound/initiate`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function getSessionEvents(sessionId, afterEventId = null) {
  let url = `${CONFIG.apiUrl}api/sessions/${sessionId}/events`;
  if (afterEventId) url += `?after=${encodeURIComponent(afterEventId)}`;
  const response = await apiFetch(url, { method: "GET" });
  return response.events || [];
}
